var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\nOffered by<br/>\n<a href=\"#/market-information/players/tso/{{networkPoint.tso0Id}}\" target=\"_blank\">\n<img ng-src=\"{{ stageConfig.monolithBase }}{{networkPoint.tso0LogoSmallUrl}}\"/>\n</a>\n<a ng-href=\"#/market-information/players/tso/{{networkPoint.tso1Id}}\" target=\"_blank\" ng-show=\"networkPoint.bundled\">\n<img ng-src=\"{{ stageConfig.monolithBase }}{{networkPoint.tso1LogoSmallUrl}}\"/>\n</a>\n</div>\n";
var id1="app/_directives/pkp-tso-logo.directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;